import React from "react";

export default function PractitionersContainer({ children }) {
  return (
    <div
      className="w-full mx-auto bg-cover "
      style={{
        backgroundImage: "url(https://i.postimg.cc/jjv6vPDr/image-2.jpg)",
      }}
    >
      <div
        className=" text-white py-12 md:py-[8.6rem]"
        style={{
          backgroundImage: "url(https://i.postimg.cc/63ByTmcr/Group-8.png)",
        }}
      >
        {children}
      </div>
    </div>
  );
}
